import type { TextPropView } from '@consta/uikit/Text'
import type { TextFieldPropOnChange, TextFieldProps } from '@consta/uikit/TextField'
import type { NumericMode } from '@library/components'
import type { Nullable } from '@library/types'
import type { FC } from 'react'

import { SingleInput } from '../SingleInput'
import { SettingContainer } from './SettingContainer'

type SettingNumberProps = {
  step?: number
  className?: string
  state?: TextFieldProps<'text'>['state']
  label: string
  errorText?: string
  value: Nullable<string | number>
  mode?: NumericMode
  placeholder?: string
  onChange: TextFieldPropOnChange
  onSetDefault?: () => Nullable<string>
  units?: string
  containerClassName?: string
  disabled?: boolean
  view?: TextPropView
}

export const SettingNumber: FC<SettingNumberProps> = ({
  onChange,
  onSetDefault,
  step,
  label,
  value,
  mode,
  errorText,
  className,
  placeholder,
  state,
  units,
  containerClassName,
  disabled,
  view,
}) => {
  return (
    <SettingContainer label={label} className={containerClassName} view={view}>
      <SingleInput
        units={units}
        className={className}
        placeholder={placeholder}
        status={state}
        value={value}
        mode={mode}
        errorText={errorText}
        step={step}
        withClearButton={true}
        disabled={disabled}
        onChange={onChange}
        onSetDefault={onSetDefault}
      />
    </SettingContainer>
  )
}
